import { graphql, useStaticQuery } from '@amazeelabs/gatsby-plugin-operations';
import { SiteMetadataQuery } from '@custom/schema';

export const useSiteMetadataQuery = () =>
  useStaticQuery(graphql(SiteMetadataQuery));
